import './analyzers.scss';
import { ToolbarSimple } from '../../components';
import InfoAnalyzers from '../../components/library/info-analyzers/infoAnalyzers';
import { useState, useCallback, memo } from 'react';
import { SysI_Analizadores } from '../../types/types.analizadores';
import ModalTracerByAnalyzer from '../../components/library/info-analyzers/Modals/ModalTracerByAnalyzer';
import HostQueryPanel from '../../components/library/info-analyzers/Modals/HostQueryPanel';
import TabPanel, { Item as TabItem } from 'devextreme-react/tab-panel';

// Componente separado para el panel izquierdo que no se re-renderiza
const AnalyzerDetailPanel = memo<{ selectedAnalyzer: SysI_Analizadores | undefined }>(({ selectedAnalyzer }) => {
  if (!selectedAnalyzer) {
    return null;
  }

  // Si Az_ManualHQ es true, mostrar pestañas
  if (selectedAnalyzer.Az_ManualHQ) {
    return (
      <div className="analyzer-tabs-container">
        <h4>{selectedAnalyzer.Az_Nombre}</h4>
        <TabPanel
          className="analyzer-tab-panel"
          animationEnabled={true}
          swipeEnabled={false}
          deferRendering={false}
        >
          <TabItem title="Resultados">
            <div className="tab-content">
              <ModalTracerByAnalyzer analyzer={selectedAnalyzer} orientation='vertical' />
            </div>
          </TabItem>
          <TabItem title="Enviar Datos Analizador">
            <div className="tab-content">
              <HostQueryPanel analyzer={selectedAnalyzer} />
            </div>
          </TabItem>
        </TabPanel>
      </div>
    );
  }

  // Si Az_ManualHQ es false, mantener el comportamiento original
  return (
    <div>
      <h4>{selectedAnalyzer.Az_Nombre}</h4>
      <ModalTracerByAnalyzer analyzer={selectedAnalyzer} orientation='vertical' />
    </div>
  );
});

const Index = () => {
  const [selectedAnalyzer, setSelectedAnalyzer] = useState<SysI_Analizadores | undefined>(undefined);

  const handleAnalyzerClick = useCallback((analyzer: SysI_Analizadores) => {
    setSelectedAnalyzer(analyzer);
  }, []);  
  
  return (
    <div className='view-wrapper-fixed'>
      <ToolbarSimple title='Analizadores'>
        <div className='split-container'>
          <div className='right-pane'>
            <InfoAnalyzers orientation='vertical' handleClick={handleAnalyzerClick} />
          </div>          
          <div className='left-pane'>
            <AnalyzerDetailPanel selectedAnalyzer={selectedAnalyzer} />
          </div>
        </div>
      </ToolbarSimple>
    </div>
  );
};

export default Index;
